// @generated by TypeGen from Bridge/NativeBridge - DO NOT EDIT

import {
  bridgeCapability,
  bridgeRequest,
  connectBridgeHost,
  createManifestBridgeFacade,
} from "app-base/bridge"
import type {
  BridgeAPI,
  BridgeCapabilityToken,
  BridgeHostConnection,
  BridgeRequestToken,
  ManifestBridgeAPI,
} from "app-base/bridge"

import type { IURLNavigationRequest } from "../AppBaseWebView/URLNavigation"
import type { ILogbookNativeMessageLog, ILogbookNativeMessagePlayAlarm, ILogbookNativeMessagePrintAction, ILogbookNativeMessageSetNetworkKeepAlive, ILogbookNativeMessageShowNotification, ILogbookNativeMessageStopAlarm } from "../LogbookApp/NativeApp"
import type { ILogPayload, INativeSignInBridgeResponse } from "../LogbookApple/LogbookAppleCapabilities"

export const AndroidBridgeManifestRequests = {
  appStyles: bridgeRequest<"logbook.android.next", "appStyles", void, string[]>("logbook.android.next", "appStyles") as BridgeRequestToken<"logbook.android.next", "appStyles", void, string[]>,
  deviceLanguage: bridgeRequest<"logbook.android.next", "deviceLanguage", void, string>("logbook.android.next", "deviceLanguage") as BridgeRequestToken<"logbook.android.next", "deviceLanguage", void, string>,
  log: bridgeRequest<"logbook.android.next", "log", ILogbookNativeMessageLog, void>("logbook.android.next", "log") as BridgeRequestToken<"logbook.android.next", "log", ILogbookNativeMessageLog, void>,
  showNotification: bridgeRequest<"logbook.android.next", "showNotification", ILogbookNativeMessageShowNotification, void>("logbook.android.next", "showNotification") as BridgeRequestToken<"logbook.android.next", "showNotification", ILogbookNativeMessageShowNotification, void>,
  playAlarm: bridgeRequest<"logbook.android.next", "playAlarm", ILogbookNativeMessagePlayAlarm, void>("logbook.android.next", "playAlarm") as BridgeRequestToken<"logbook.android.next", "playAlarm", ILogbookNativeMessagePlayAlarm, void>,
  stopAlarm: bridgeRequest<"logbook.android.next", "stopAlarm", ILogbookNativeMessageStopAlarm, void>("logbook.android.next", "stopAlarm") as BridgeRequestToken<"logbook.android.next", "stopAlarm", ILogbookNativeMessageStopAlarm, void>,
  printAction: bridgeRequest<"logbook.android.next", "printAction", ILogbookNativeMessagePrintAction, void>("logbook.android.next", "printAction") as BridgeRequestToken<"logbook.android.next", "printAction", ILogbookNativeMessagePrintAction, void>,
} as const;

export type AndroidBridgeManifestRequest =
  (typeof AndroidBridgeManifestRequests)[keyof typeof AndroidBridgeManifestRequests];

export type AndroidBridgeManifestCallableRequest =
  typeof AndroidBridgeManifestRequests["appStyles"]
  | typeof AndroidBridgeManifestRequests["deviceLanguage"]
  | typeof AndroidBridgeManifestRequests["log"]
  | typeof AndroidBridgeManifestRequests["showNotification"]
  | typeof AndroidBridgeManifestRequests["playAlarm"]
  | typeof AndroidBridgeManifestRequests["stopAlarm"]
  | typeof AndroidBridgeManifestRequests["printAction"];

export const AndroidBridgeManifestCapabilities = {
} as const;

export type AndroidBridgeManifestCapability =
  (typeof AndroidBridgeManifestCapabilities)[keyof typeof AndroidBridgeManifestCapabilities];

export interface AndroidBridgeManifestValues {
  readonly formFactor: string;
  readonly platform: string;
  readonly deviceLanguage: string;
}

export type AndroidBridgeManifestBridge = ManifestBridgeAPI<
  "logbook.android.next",
  AndroidBridgeManifestRequest,
  AndroidBridgeManifestCallableRequest,
  AndroidBridgeManifestValues,
  AndroidBridgeManifestCapability
>;

export interface AndroidBridgeManifestConnection {
  readonly kind: "manifest";
  readonly manifestID: "logbook.android.next";
  readonly bridge: AndroidBridgeManifestBridge;
}

function connectAndroidBridgeManifest(
  connection: Extract<BridgeHostConnection, { readonly kind: "manifest" }>,
): AndroidBridgeManifestConnection {
  return {
    ...connection,
    manifestID: "logbook.android.next",
    bridge: createManifestBridgeFacade<
      "logbook.android.next",
      AndroidBridgeManifestRequest,
      AndroidBridgeManifestCallableRequest,
      AndroidBridgeManifestValues,
      AndroidBridgeManifestCapability
    >("logbook.android.next", connection.bridge),
  };
}

export const AppleBridgeManifestRequests = {
  appStyles: bridgeRequest<"logbook.apple", "appStyles", void, string[]>("logbook.apple", "appStyles") as BridgeRequestToken<"logbook.apple", "appStyles", void, string[]>,
  deviceLanguage: bridgeRequest<"logbook.apple", "deviceLanguage", void, string>("logbook.apple", "deviceLanguage") as BridgeRequestToken<"logbook.apple", "deviceLanguage", void, string>,
  log: bridgeRequest<"logbook.apple", "log", ILogPayload, void>("logbook.apple", "log") as BridgeRequestToken<"logbook.apple", "log", ILogPayload, void>,
  showNotification: bridgeRequest<"logbook.apple", "showNotification", ILogbookNativeMessageShowNotification, void>("logbook.apple", "showNotification") as BridgeRequestToken<"logbook.apple", "showNotification", ILogbookNativeMessageShowNotification, void>,
  playAlarm: bridgeRequest<"logbook.apple", "playAlarm", ILogbookNativeMessagePlayAlarm, void>("logbook.apple", "playAlarm") as BridgeRequestToken<"logbook.apple", "playAlarm", ILogbookNativeMessagePlayAlarm, void>,
  stopAlarm: bridgeRequest<"logbook.apple", "stopAlarm", ILogbookNativeMessageStopAlarm, void>("logbook.apple", "stopAlarm") as BridgeRequestToken<"logbook.apple", "stopAlarm", ILogbookNativeMessageStopAlarm, void>,
  nativeSignIn: bridgeRequest<"logbook.apple", "nativeSignIn", void, INativeSignInBridgeResponse>("logbook.apple", "nativeSignIn") as BridgeRequestToken<"logbook.apple", "nativeSignIn", void, INativeSignInBridgeResponse>,
  printAction: bridgeRequest<"logbook.apple", "printAction", ILogbookNativeMessagePrintAction, void>("logbook.apple", "printAction") as BridgeRequestToken<"logbook.apple", "printAction", ILogbookNativeMessagePrintAction, void>,
  setNetworkKeepAlive: bridgeRequest<"logbook.apple", "setNetworkKeepAlive", ILogbookNativeMessageSetNetworkKeepAlive, void>("logbook.apple", "setNetworkKeepAlive") as BridgeRequestToken<"logbook.apple", "setNetworkKeepAlive", ILogbookNativeMessageSetNetworkKeepAlive, void>,
  "webView.openURL": bridgeRequest<"logbook.apple", "webView.openURL", IURLNavigationRequest, void>("logbook.apple", "webView.openURL") as BridgeRequestToken<"logbook.apple", "webView.openURL", IURLNavigationRequest, void>,
} as const;

export type AppleBridgeManifestRequest =
  (typeof AppleBridgeManifestRequests)[keyof typeof AppleBridgeManifestRequests];

export type AppleBridgeManifestCallableRequest =
  typeof AppleBridgeManifestRequests["appStyles"]
  | typeof AppleBridgeManifestRequests["deviceLanguage"]
  | typeof AppleBridgeManifestRequests["log"]
  | typeof AppleBridgeManifestRequests["showNotification"]
  | typeof AppleBridgeManifestRequests["playAlarm"]
  | typeof AppleBridgeManifestRequests["stopAlarm"]
  | typeof AppleBridgeManifestRequests["nativeSignIn"]
  | typeof AppleBridgeManifestRequests["printAction"]
  | typeof AppleBridgeManifestRequests["setNetworkKeepAlive"]
  | typeof AppleBridgeManifestRequests["webView.openURL"];

export const AppleBridgeManifestCapabilities = {
  nativeSignIn: bridgeCapability("logbook.apple", "nativeSignIn") as BridgeCapabilityToken<"logbook.apple", "nativeSignIn">,
  "webView.urlNavigation.overlay": bridgeCapability("logbook.apple", "webView.urlNavigation.overlay") as BridgeCapabilityToken<"logbook.apple", "webView.urlNavigation.overlay">,
  "webView.urlNavigation.acknowledged": bridgeCapability("logbook.apple", "webView.urlNavigation.acknowledged") as BridgeCapabilityToken<"logbook.apple", "webView.urlNavigation.acknowledged">,
} as const;

export type AppleBridgeManifestCapability =
  (typeof AppleBridgeManifestCapabilities)[keyof typeof AppleBridgeManifestCapabilities];

export interface AppleBridgeManifestValues {
  readonly formFactor: string;
  readonly platform: string;
  readonly deviceLanguage: string;
}

export type AppleBridgeManifestBridge = ManifestBridgeAPI<
  "logbook.apple",
  AppleBridgeManifestRequest,
  AppleBridgeManifestCallableRequest,
  AppleBridgeManifestValues,
  AppleBridgeManifestCapability
>;

export interface AppleBridgeManifestConnection {
  readonly kind: "manifest";
  readonly manifestID: "logbook.apple";
  readonly bridge: AppleBridgeManifestBridge;
}

function connectAppleBridgeManifest(
  connection: Extract<BridgeHostConnection, { readonly kind: "manifest" }>,
): AppleBridgeManifestConnection {
  return {
    ...connection,
    manifestID: "logbook.apple",
    bridge: createManifestBridgeFacade<
      "logbook.apple",
      AppleBridgeManifestRequest,
      AppleBridgeManifestCallableRequest,
      AppleBridgeManifestValues,
      AppleBridgeManifestCapability
    >("logbook.apple", connection.bridge),
  };
}

export const WindowsBridgeManifestRequests = {
  appStyles: bridgeRequest<"logbook.windows.next", "appStyles", void, string[]>("logbook.windows.next", "appStyles") as BridgeRequestToken<"logbook.windows.next", "appStyles", void, string[]>,
  deviceLanguage: bridgeRequest<"logbook.windows.next", "deviceLanguage", void, string>("logbook.windows.next", "deviceLanguage") as BridgeRequestToken<"logbook.windows.next", "deviceLanguage", void, string>,
  log: bridgeRequest<"logbook.windows.next", "log", ILogbookNativeMessageLog, void>("logbook.windows.next", "log") as BridgeRequestToken<"logbook.windows.next", "log", ILogbookNativeMessageLog, void>,
  showNotification: bridgeRequest<"logbook.windows.next", "showNotification", ILogbookNativeMessageShowNotification, void>("logbook.windows.next", "showNotification") as BridgeRequestToken<"logbook.windows.next", "showNotification", ILogbookNativeMessageShowNotification, void>,
  playAlarm: bridgeRequest<"logbook.windows.next", "playAlarm", ILogbookNativeMessagePlayAlarm, void>("logbook.windows.next", "playAlarm") as BridgeRequestToken<"logbook.windows.next", "playAlarm", ILogbookNativeMessagePlayAlarm, void>,
  stopAlarm: bridgeRequest<"logbook.windows.next", "stopAlarm", ILogbookNativeMessageStopAlarm, void>("logbook.windows.next", "stopAlarm") as BridgeRequestToken<"logbook.windows.next", "stopAlarm", ILogbookNativeMessageStopAlarm, void>,
} as const;

export type WindowsBridgeManifestRequest =
  (typeof WindowsBridgeManifestRequests)[keyof typeof WindowsBridgeManifestRequests];

export type WindowsBridgeManifestCallableRequest =
  typeof WindowsBridgeManifestRequests["appStyles"]
  | typeof WindowsBridgeManifestRequests["deviceLanguage"]
  | typeof WindowsBridgeManifestRequests["log"]
  | typeof WindowsBridgeManifestRequests["showNotification"]
  | typeof WindowsBridgeManifestRequests["playAlarm"]
  | typeof WindowsBridgeManifestRequests["stopAlarm"];

export const WindowsBridgeManifestCapabilities = {
} as const;

export type WindowsBridgeManifestCapability =
  (typeof WindowsBridgeManifestCapabilities)[keyof typeof WindowsBridgeManifestCapabilities];

export interface WindowsBridgeManifestValues {
  readonly formFactor: string;
  readonly platform: string;
  readonly deviceLanguage: string;
}

export type WindowsBridgeManifestBridge = ManifestBridgeAPI<
  "logbook.windows.next",
  WindowsBridgeManifestRequest,
  WindowsBridgeManifestCallableRequest,
  WindowsBridgeManifestValues,
  WindowsBridgeManifestCapability
>;

export interface WindowsBridgeManifestConnection {
  readonly kind: "manifest";
  readonly manifestID: "logbook.windows.next";
  readonly bridge: WindowsBridgeManifestBridge;
}

function connectWindowsBridgeManifest(
  connection: Extract<BridgeHostConnection, { readonly kind: "manifest" }>,
): WindowsBridgeManifestConnection {
  return {
    ...connection,
    manifestID: "logbook.windows.next",
    bridge: createManifestBridgeFacade<
      "logbook.windows.next",
      WindowsBridgeManifestRequest,
      WindowsBridgeManifestCallableRequest,
      WindowsBridgeManifestValues,
      WindowsBridgeManifestCapability
    >("logbook.windows.next", connection.bridge),
  };
}

export type NativeBridgeConnection =
  | AndroidBridgeManifestConnection
  | AppleBridgeManifestConnection
  | WindowsBridgeManifestConnection
  | Extract<BridgeHostConnection, { readonly kind: "raw" | "null" }>
  | {
      readonly kind: "unknown";
      readonly manifestID: string;
      readonly bridge: BridgeAPI;
    };

export function connectNativeBridge(
  ...args: Parameters<typeof connectBridgeHost>
): NativeBridgeConnection {
  const connection = connectBridgeHost(...args);
  if (connection.kind !== "manifest") {
    return connection;
  }
  switch (connection.manifestID) {
    case "logbook.android.next":
      return connectAndroidBridgeManifest(connection);
    case "logbook.apple":
      return connectAppleBridgeManifest(connection);
    case "logbook.windows.next":
      return connectWindowsBridgeManifest(connection);
    default:
      return {
        kind: "unknown",
        manifestID: connection.manifestID,
        bridge: connection.bridge,
      };
  }
}
